import { DynamicFormValidation, SelectOption } from "../form-validation/dynamic";
import { PSRole } from "./roles";
import { IUploadContext } from "./upload";

export interface IForm {
	id: string;
	name: string;
	description: string;
	sections: ISection[];
	fieldsMap: { [fieldId: string]: IFormField };
	fields: IFormField[];
	order: number;
	active: boolean;
	hide?: boolean;
	updateKey?: number;
	hideSubmit?: boolean;
	btnText?: string;
	successMsg?: string;
	omitContactFields?: boolean;
	sendEmailTo?: string[];
	psRoles?: PSRole[];
	noEdit?: boolean;
	department_id?: string;
	ecwidSku?: number;
	productPrice?: number;
	priceMultiplierField?: string;
}

export interface ISection {
	id: string;
	name?: string;
	description?: string;
	fields: IFormField[];
	order: number;
	active: boolean;
	noBorder?: boolean;
}

export const COMMON_FIELD_TYPES_ARR = [
	"text",
	"textarea",
	"number",
	"phone",
	"email",
	"address",
	"select",
	"yes/no",
	"boolean",
	"collection",
	"checkbox",
	"link",
];

export const FIELD_TYPES_ARR = [
	...COMMON_FIELD_TYPES_ARR,
	"date",
	"datetime",
	"autocomplete",
	"yes/no",
	"boolean",
	"collection",
	"media",
	"checkbox",
	"color",
	"link",
	"imageUrl",
	"html",
	"password",
	"chips",
	"focusRow",
	"list",
	"widgets",
	"css-editor",
] as const;
type FieldTypesTuple = typeof FIELD_TYPES_ARR;
export type FormFieldType = FieldTypesTuple[number];

export interface IFormField {
	id: string;
	order: number;
	section?: string;
	label: string;
	fieldType: FormFieldType;
	listType?: "textBlock" | "formField" | "formSection" | "quotes" | "media";
	optional?: boolean;
	placeholder?: string;
	minLength?: number;
	maxLength?: number;
	fromUserData?: boolean;
	userDataField?: string;
	persistUserData?: boolean;
	defaultValue?: any;
	disabled?: boolean;
	fields?: { [key: string]: IFormField };
	permission?: string;
	noEdit?: boolean;
	canEdit?: (data) => boolean;
	mediaOptions?: Partial<IUploadContext>;
	displayContentPreview?: boolean;
	isDepartment?: boolean;
	clientFilter?: (o) => boolean;
}

export interface ISelectFormField extends IFormField {
	selectValues: (string | number | SelectOption)[];
	adminSelectValues?: (string | number | SelectOption)[];
	collectionName?: string;
	collectionDisplayField?: string;
	useFirewire?: boolean;
	filterQuery?: string;
	datasource?: any[];
	findDrillItem?: (item, props) => boolean;
}

export type OnInputChange = (field: IFormField, value: any) => any;

export type IFormInputCustomProps = {
	label?: string;
	field: IFormField;
	border: 1;
	enabled: boolean;
	onInputChange: OnInputChange;
	onBlur: (fieldConfig: IFormField) => any;
	invalid?: boolean;
	showIcon?: boolean;
	isCorrect?: boolean;
	showAsterisks?: boolean;
	asteriskTemplate?;
};
export type IFormInputProps = {
	key: string;
	formField: IFormField;
	maxLength?: number;
	defaultValue: any;
	placeholder?: string;
	customProps: IFormInputCustomProps;
};

export type FormListItem = {
	checked: boolean;
	value: string | number;
	form?: DynamicFormValidation;
};

export const isSystemForm = (formId: string): boolean => formId === "facility" || formId === "member";
